import { Checkbox, FormControlLabel } from '@material-ui/core'
import { Button } from 'components/facets'
import { useUser } from 'components/providers/UserProvider'
import { useState } from 'react'
import Accordion from 'react-bootstrap/Accordion'
import { useTranslation } from 'react-i18next'
import { InventoryArticle } from 'shared'
import { PublishChangesEditedCardRow } from '../PublishChangesEditedCardRow'
import './../publish-changes-dialog.css'

export interface articlesChangedProps {
  articlesChanged: InventoryArticle[]
  onPublishChanges: () => Promise<void>
  onCancelClick: () => void
}

export const PublishChangesSummary = ({
  articlesChanged,
  onPublishChanges,
  onCancelClick,
}: articlesChangedProps): JSX.Element => {
  const [canPublish, setCanPublish] = useState<boolean>(false)
  const { t } = useTranslation()
  const { user } = useUser()

  const [disablePublishButton, setDisablePublishButton] = useState<boolean>(
    !!user.subscription.dailyArticlePublishLimit &&
      user.articlesPublishedToday + articlesChanged.length >
        user.subscription.dailyArticlePublishLimit
  )
  setDisablePublishButton

  const changePublishAutorization = (): void => {
    setCanPublish(!canPublish)
  }

  return (
    <div data-testid="publish-changes-summary" style={{ width: '950px' }}>
      <div>
        <p>
          {/* You have edited <span className="amount-edited-cards">{articlesChanged.length}</span>{' '}
          cards, do you want to proceed? */}
          {t('stockPricing.actions.editedCardsPt1')}{' '}
          <span className="amount-edited-cards">{articlesChanged.length}</span>{' '}
          {t('stockPricing.actions.editedCardsPt2')}
        </p>
      </div>
      {articlesChanged.length > 0 && (
        <div>
          <Accordion defaultActiveKey={['0']} alwaysOpen>
            <Accordion.Item eventKey="0">
              <Accordion.Header>{t('stockPricing.actions.editedCardsTitle')}</Accordion.Header>
              <Accordion.Body
                className="d-flex justify-content-center"
                style={{ maxHeight: '500px', overflowY: 'auto' }}
              >
                <div>
                  <table className="table-width">
                    <tbody>
                      {articlesChanged.map((article: InventoryArticle) => {
                        return (
                          <PublishChangesEditedCardRow
                            key={article.id}
                            article={article}
                            currency={user.currency}
                          />
                        )
                      })}
                    </tbody>
                  </table>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      )}

      <div>
        {articlesChanged.length > 0 ? (
          <div className="d-flex justify-content-between pt-5">
            <div className="d-flex align-items-center px-2">
              <FormControlLabel
                control={
                  <Checkbox
                    data-testid="publish-changes-checkbox"
                    onChange={changePublishAutorization}
                    name="checkedB"
                    color="primary"
                    disabled={disablePublishButton}
                  />
                }
                label={t('publish.reviewDonePT')}
              />
            </div>
            <div className="d-flex">
              <div className="mx-3">
                <Button
                  onClick={onCancelClick}
                  color="primary"
                  data-testid="cancel-publish-changes-btn"
                  variant="outlined"
                >
                  {t('common.close')}
                </Button>
              </div>
              <div>
                <Button
                  variant="contained"
                  onClick={onPublishChanges}
                  color="primary"
                  tooltip={
                    disablePublishButton
                      ? t('addArticles.articlesPublishedOverLimit', {
                          count:
                            user.subscription.dailyArticlePublishLimit! -
                            user.articlesPublishedToday,
                        })
                      : ''
                  }
                  data-testid="confirm-publish-changes-btn"
                  disabled={!canPublish || disablePublishButton}
                >
                  {t('common.confirm')}
                </Button>
              </div>
            </div>
          </div>
        ) : (
          <div className="d-flex justify-content-between">
            <div className="px-2 d-flex align-items-center">
              <p>{t('publish.noRealChanges')}</p>
            </div>
            <div className="d-flex">
              <Button
                onClick={onCancelClick}
                variant="contained"
                color="primary"
                data-testid="cancel-publish-changes-btn"
              >
                {t('common.close')}
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
